export default "__VITE_ASSET__CCX$YA3E__"